import React, { useEffect, useState } from "react";
import { useManageUserAds } from "../../../../hooks/useManageUserAds";
import { useDispatch, useSelector } from "react-redux";
import { Route, Routes } from "react-router-dom";
import { getAdsList } from "../../../../features/reducers/ads";
import AdSettings from "./AdSettings";
import axiosWithAuth from "../../../../utils/axiosWithAuth";
// import AdsAnalytics from "../ManageAnalytics/AdsAnalytics";

export default function ManageAdsUser(props) {
  const { user } = props;

  const [adsList, setAdsList] = useState([]);

  useEffect(() => {
    getAdsUser();
  }, []);

  const getAdsUser = async () => {
    try {
      const response = await axiosWithAuth().get(
        `/api/advertisement/clientpay`,
      );
      setAdsList(response.data);
    } catch (error) {
      console.error("Error getting user ads:", error);
    }
  };

  // Custom hook to manage the creation/deletion of user listing
  const hookData = {
    type: "pay",
    isForBusiness: true,
    dispatchAction: getAdsUser,
    itemType: "advertisement",
    deleteItemAPI: "/api/advertisement/delete",
    modalData: {
      title: "Create New Ad 1",
      fieldLabel: "Ad Name",
    },
  };

  const [modalComponent, CreateItemButton, ListComponent] =
    useManageUserAds(hookData);

  return (
    <div>
      <div className="content-box">
        <Routes>
          <Route
            path="/"
            element={
              <>
                <ListComponent
                  emptyMessage="Seems like you don't have an advertisements."
                  btnText="Create New Ad"
                  listItems={adsList}
                />

                <CreateItemButton btnText="Create New Ad" />
              </>
            }
            exact
          />

          <Route path="/:id" element={<AdSettings />} exact />

          {/* <Route path="/:id/insights" element={<AdsAnalytics />} /> */}
        </Routes>
      </div>

      {modalComponent}
    </div>
  );
}
